// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Basic styling for printable documents - Inherited from PrintableContract.css conceptually */
.printable-container {
  font-family: 'Arial', sans-serif;
  padding: 20px;
  max-width: 800px; /* Adjust as needed */
  margin: auto;
  background-color: #fff;
  color: #000;
}

.printable-header {
  text-align: center;
  margin-bottom: 30px;
  border-bottom: 1px solid #ccc;
  padding-bottom: 15px;
}

.printable-header h1 {
  margin: 0 0 5px 0;
  font-size: 1.8em;
}

.printable-header p {
  margin: 2px 0;
  font-size: 1em;
  color: #333;
}

section {
  margin-bottom: 25px;
}

section h2 {
  font-size: 1.3em;
  margin-bottom: 15px;
  border-bottom: 1px solid #eee;
  padding-bottom: 5px;
  color: #111;
}

.parties p,
.payment-terms p {
  margin: 8px 0;
  line-height: 1.5;
  font-size: 0.95em;
}

/* Table Styling */
.specification-table table {
  width: 100%;
  border-collapse: collapse;
  margin-top: 10px;
  font-size: 0.9em;
}

.specification-table th,
.specification-table td {
  border: 1px solid #ddd;
  padding: 8px;
  text-align: left;
  vertical-align: top;
}

.specification-table th {
  background-color: #f2f2f2;
  font-weight: bold;
}

.specification-table td:first-child { /* № */
  text-align: center;
  width: 40px;
}

.specification-table td:nth-child(5), /* Цена */
.specification-table td:nth-child(6), /* Итого */
.specification-table tfoot td { /* Footer cells */
  text-align: right;
}

.specification-table tfoot td {
  border-top: 2px solid #aaa; /* Thicker border for footer */
  font-weight: bold;
}


/* Signature Section */
.signatures {
  margin-top: 40px;
}

.signature-blocks {
  display: flex;
  justify-content: space-between;
  margin-top: 20px;
  padding-top: 20px;
  border-top: 1px solid #eee;
}

.signature-block {
  width: 45%;
  font-size: 0.9em;
}

.signature-block p {
  margin-bottom: 5px;
}

.signature-block strong {
  font-weight: bold;
}

.printable-footer {
  margin-top: 40px;
  padding-top: 15px;
  border-top: 1px solid #ccc;
  text-align: center;
  font-size: 0.8em;
  color: #555;
}

/* Print-specific styles */
@media print {
  body {
    margin: 0;
    padding: 0;
    background-color: #fff;
  }
  .printable-container {
    max-width: 100%;
    box-shadow: none;
    margin: 0;
    padding: 10mm;
    border: none;
  }
  .no-print {
    /* display: none; */
  }
  .specification-table th,
  .specification-table td {
    border: 1px solid #aaa !important;
  }
  tr, section, .signature-block {
    page-break-inside: avoid;
  }
  h1, h2 {
    page-break-after: avoid;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/printable/PrintableContractAppendix.css"],"names":[],"mappings":"AAAA,8FAA8F;AAC9F;EACE,gCAAgC;EAChC,aAAa;EACb,gBAAgB,EAAE,qBAAqB;EACvC,YAAY;EACZ,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,6BAA6B;EAC7B,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,cAAc;EACd,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,6BAA6B;EAC7B,mBAAmB;EACnB,WAAW;AACb;;AAEA;;EAEE,aAAa;EACb,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA,kBAAkB;AAClB;EACE,WAAW;EACX,yBAAyB;EACzB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;;EAEE,sBAAsB;EACtB,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA,sCAAsC,MAAM;EAC1C,kBAAkB;EAClB,WAAW;AACb;;AAEA;;gCAEgC,iBAAiB;EAC/C,iBAAiB;AACnB;;AAEA;EACE,0BAA0B,EAAE,8BAA8B;EAC1D,iBAAiB;AACnB;;;AAGA,sBAAsB;AACtB;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,gBAAgB;EAChB,iBAAiB;EACjB,0BAA0B;AAC5B;;AAEA;EACE,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,0BAA0B;EAC1B,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;AACb;;AAEA,0BAA0B;AAC1B;EACE;IACE,SAAS;IACT,UAAU;IACV,sBAAsB;EACxB;EACA;IACE,eAAe;IACf,gBAAgB;IAChB,SAAS;IACT,aAAa;IACb,YAAY;EACd;EACA;IACE,mBAAmB;EACrB;EACA;;IAEE,iCAAiC;EACnC;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,uBAAuB;EACzB;AACF","sourcesContent":["/* Basic styling for printable documents - Inherited from PrintableContract.css conceptually */\n.printable-container {\n  font-family: 'Arial', sans-serif;\n  padding: 20px;\n  max-width: 800px; /* Adjust as needed */\n  margin: auto;\n  background-color: #fff;\n  color: #000;\n}\n\n.printable-header {\n  text-align: center;\n  margin-bottom: 30px;\n  border-bottom: 1px solid #ccc;\n  padding-bottom: 15px;\n}\n\n.printable-header h1 {\n  margin: 0 0 5px 0;\n  font-size: 1.8em;\n}\n\n.printable-header p {\n  margin: 2px 0;\n  font-size: 1em;\n  color: #333;\n}\n\nsection {\n  margin-bottom: 25px;\n}\n\nsection h2 {\n  font-size: 1.3em;\n  margin-bottom: 15px;\n  border-bottom: 1px solid #eee;\n  padding-bottom: 5px;\n  color: #111;\n}\n\n.parties p,\n.payment-terms p {\n  margin: 8px 0;\n  line-height: 1.5;\n  font-size: 0.95em;\n}\n\n/* Table Styling */\n.specification-table table {\n  width: 100%;\n  border-collapse: collapse;\n  margin-top: 10px;\n  font-size: 0.9em;\n}\n\n.specification-table th,\n.specification-table td {\n  border: 1px solid #ddd;\n  padding: 8px;\n  text-align: left;\n  vertical-align: top;\n}\n\n.specification-table th {\n  background-color: #f2f2f2;\n  font-weight: bold;\n}\n\n.specification-table td:first-child { /* № */\n  text-align: center;\n  width: 40px;\n}\n\n.specification-table td:nth-child(5), /* Цена */\n.specification-table td:nth-child(6), /* Итого */\n.specification-table tfoot td { /* Footer cells */\n  text-align: right;\n}\n\n.specification-table tfoot td {\n  border-top: 2px solid #aaa; /* Thicker border for footer */\n  font-weight: bold;\n}\n\n\n/* Signature Section */\n.signatures {\n  margin-top: 40px;\n}\n\n.signature-blocks {\n  display: flex;\n  justify-content: space-between;\n  margin-top: 20px;\n  padding-top: 20px;\n  border-top: 1px solid #eee;\n}\n\n.signature-block {\n  width: 45%;\n  font-size: 0.9em;\n}\n\n.signature-block p {\n  margin-bottom: 5px;\n}\n\n.signature-block strong {\n  font-weight: bold;\n}\n\n.printable-footer {\n  margin-top: 40px;\n  padding-top: 15px;\n  border-top: 1px solid #ccc;\n  text-align: center;\n  font-size: 0.8em;\n  color: #555;\n}\n\n/* Print-specific styles */\n@media print {\n  body {\n    margin: 0;\n    padding: 0;\n    background-color: #fff;\n  }\n  .printable-container {\n    max-width: 100%;\n    box-shadow: none;\n    margin: 0;\n    padding: 10mm;\n    border: none;\n  }\n  .no-print {\n    /* display: none; */\n  }\n  .specification-table th,\n  .specification-table td {\n    border: 1px solid #aaa !important;\n  }\n  tr, section, .signature-block {\n    page-break-inside: avoid;\n  }\n  h1, h2 {\n    page-break-after: avoid;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
